import React from 'react';
import './Modal.css';

interface ModalProps {
  isOpen: boolean;
  onClose?: () => void;
  title: string;
  message: string;
  type?: 'success' | 'error' | 'info' | 'warning' | 'loading';
  showCancel?: boolean;
  confirmText?: string;
  onConfirm?: () => void;
  isLoading?: boolean;
}

const Modal: React.FC<ModalProps> = ({
  isOpen,
  onClose,
  title,
  message,
  type = 'info',
  showCancel = false,
  confirmText = 'OK',
  onConfirm,
  isLoading = false,
}) => {
  if (!isOpen) return null;

  const handleConfirm = () => {
    if (onConfirm) {
      onConfirm();
    }
    if (onClose && !isLoading) {
      onClose();
    }
  };

  const handleOverlayClick = () => {
    if (onClose && !isLoading) {
      onClose();
    }
  };

  const displayType = isLoading ? 'loading' : type;

  return (
    <div className="modal-overlay" onClick={handleOverlayClick}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className={`modal-header modal-${displayType}`}>
          <h3>{title}</h3>
          {!isLoading && onClose && (
            <button className="modal-close" onClick={onClose}>×</button>
          )}
        </div>
        <div className="modal-body">
          {isLoading ? (
            <div className="modal-loading-content">
              <div className="modal-spinner"></div>
              <p>{message}</p>
            </div>
          ) : (
            <p>{message}</p>
          )}
        </div>
        {!isLoading && (
          <div className="modal-footer">
            {showCancel && (
              <button className="modal-button modal-button-secondary" onClick={onClose}>
                Cancel
              </button>
            )}
            <button className={`modal-button modal-button-primary modal-${type}`} onClick={handleConfirm}>
              {confirmText}
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default Modal;

